import {Modal} from "omoplay";

/**
 * `className` 은 omoplay Modal 의 `.modal` 박스에 붙는다(modalClasses = classNames('modal', className)).
 * 내용이 긴 팝업은 `className="modal-fit"` 을 주면 헤더·푸터가 흰 패널 안에 고정된다 —
 * 이유는 `assets/common.css` 의 `.modal.modal-fit` 주석 참조.
 */
const SuspensePopup = ({title, style, className, visible, onConfirm, confirmText, confirmDisabled, cancelText, onClose, children}) => {
  return (
      <Modal style={style} className={className} visible={visible} title={title} closable={true}
             onConfirm={onConfirm}
             confirmDisabled={confirmDisabled}
             confirmText={confirmText ?? "확인"}
             cancelText={cancelText ?? "닫기"} onCancel={onClose}
      >
        {
          children
        }
      </Modal>
  );
};

export default SuspensePopup;
